/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changePasswordPostRequestSchema } from './changePasswordPostRequestSchema.ts';
import { changePasswordPostResponseSchema } from './changePasswordPostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postChangePassword200Schema = z.lazy(() => changePasswordPostResponseSchema);

/**
 * @description 505 response
 */
export const postChangePassword505Schema = z.any();

export const postChangePasswordMutationRequestSchema = z.lazy(() => changePasswordPostRequestSchema);

export const postChangePasswordMutationResponseSchema = z.lazy(() => postChangePassword200Schema);
